import { render, staticRenderFns } from "./OrdersByStatus.vue?vue&type=template&id=5ca2d103&scoped=true&"
import script from "./OrdersByStatus.vue?vue&type=script&lang=js&"
export * from "./OrdersByStatus.vue?vue&type=script&lang=js&"
import style0 from "./OrdersByStatus.vue?vue&type=style&index=0&id=5ca2d103&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2d103",
  null
  
)

export default component.exports